import React, { FormEvent, useState } from 'react'
import { Box, Button, CircularProgress, Paper, TextField, Typography } from '@material-ui/core'
import { Link, Redirect } from 'react-router-dom'
import logo from '@assets/Logo.png'
import { requestPasswordRecovery } from './passwordRecoveryApi'

const PasswordRecoveryRequestView: React.FC = () => {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState('')

  const recoveryParams = new URLSearchParams(window.location.hash.slice(1))
  if (recoveryParams.has('challenge') && recoveryParams.has('token')) {
    return (
      <Redirect
        to={{
          pathname: '/password-recovery/reset',
          hash: window.location.hash
        }}
      />
    )
  }

  const submit = async (event: FormEvent) => {
    event.preventDefault()
    setLoading(true)
    setError('')
    try {
      await requestPasswordRecovery(email.trim().toLowerCase())
      setSubmitted(true)
    } catch (_requestError) {
      setError('No pudimos procesar la solicitud. Intenta nuevamente en unos minutos.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="center_view">
      <img src={logo} alt="CO Capitalizaciones" style={{ height: '7em' }} />
      <Paper
        elevation={3}
        style={{
          width: 'min(100%, 440px)',
          padding: '32px 28px',
          borderRadius: 16
        }}
      >
        <Typography variant="h5" align="center" gutterBottom>
          Recupera tu contraseña
        </Typography>
        {submitted ? (
          <Typography align="center" color="textSecondary">
            Si existe una cuenta con ese correo, recibirás instrucciones para recuperar el acceso.
          </Typography>
        ) : (
          <form onSubmit={submit}>
            <Typography color="textSecondary" align="center" paragraph>
              Te enviaremos un enlace seguro para crear una contraseña nueva.
            </Typography>
            <TextField
              fullWidth
              required
              type="email"
              label="Correo electrónico"
              autoComplete="email"
              margin="normal"
              value={email}
              disabled={loading}
              onChange={event => setEmail(event.target.value)}
            />
            {error && (
              <Typography color="error" role="alert">
                {error}
              </Typography>
            )}
            <Box marginTop={3}>
              <Button fullWidth type="submit" variant="contained" color="primary" disabled={loading}>
                {loading ? <CircularProgress size={22} /> : 'Enviar instrucciones'}
              </Button>
            </Box>
          </form>
        )}
        <Box textAlign="center" marginTop={3}>
          <Link to="/login" style={{ color: '#e65f00', fontWeight: 600 }}>
            Volver a iniciar sesión
          </Link>
        </Box>
      </Paper>
    </div>
  )
}

export default PasswordRecoveryRequestView
